import { useCallback, useRef } from 'react'

import { Modal } from 'antd'

import type { ProcedureItem } from 'features/Procedure/state/procedure-api.type'

import { ManageProductForm, type ManageProductFormHandle } from './manage-product-form'
import styles from './manage-product.module.scss'
import { ProductUpcScanner } from './product-upc-scanner'

type Props = {
  isVisible: boolean
  onClose: () => void
  procedure?: ProcedureItem | null
  forceAddMode?: boolean
  selectedEncounterUid: string | null
}

export const ManageProduct = ({
  isVisible,
  onClose,
  procedure,
  forceAddMode = false,
  selectedEncounterUid,
}: Props) => {
  const formRef = useRef<ManageProductFormHandle>(null)

  const isEditMode = !!procedure && !forceAddMode
  const modalTitle = isEditMode ? 'Edit Product' : 'Add Product'

  const handleModalClose = useCallback(() => {
    formRef.current?.tryClose()
  }, [])

  const handleScan = useCallback((upc: string) => {
    void formRef.current?.scanUpc(upc)
  }, [])

  return (
    <Modal
      classNames={{ content: styles.modalContent }}
      open={isVisible}
      keyboard
      maskClosable={false}
      onCancel={handleModalClose}
      title={modalTitle}
      footer={null}
      style={{ top: 20 }}
      destroyOnHidden>
      <ManageProductForm
        ref={formRef}
        procedure={procedure}
        forceAddMode={forceAddMode}
        selectedEncounterUid={selectedEncounterUid}
        onClose={onClose}
        scannerSlot={<ProductUpcScanner onScan={handleScan} />}
      />
    </Modal>
  )
}
